import {
    convertUniversalDateTimeToPersianDateTime,
    RaikoCardInfoTypeOne,
    RaikoCardInfoTypeOneItemGenerator,
    RaikoGridOneColumn,
    RaikoGridThreeColumn,
    RaikoMobileInputOutlined,
    RaikoNumberInputOutlined,
    RaikoPagination,
    RaikoSectionContainer,
    RaikoSimpleInputOutlined, RaikoStepper,
    RaikoTableSearchContainer,
    RaikoTableTitleContainer,
    showServerErrorMessage
} from "@moeindal/base-raiko-panel-components";
import {GameTeamMemberService} from "../../serverService/gameService/GameTeamMemberService";
import {LoadingHelper} from "../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import {useEffect, useState} from "react";
import {useDebounce} from "@uidotdev/usehooks";
import {css} from "@emotion/css";
import SelectPlayerFromList from "./selectPlayerFromList/SelectPlayerFromList";
import AddPlayerToTeam from "./addPlayerToTeam/AddPlayerToTeam";

export default function PlayerSelection({gameTeamId, handleClosePlayerSelectionDialog}) {

    const [stepCounter, setStepCounter] = useState(0);
    const [playerInfo, setPlayerInfo] = useState();

    function handleSelectNewPlayer(playerInfo) {
        setPlayerInfo(playerInfo)
        setStepCounter(playerSelectionSteps.PLAYER_INFO.activeStep)
    }


    return (
        <RaikoGridOneColumn className={css`
            padding: .5rem 1rem 1rem 1rem;
            gap: 2rem;
            width: 100%`}>
            <RaikoStepper
                activeStep={stepCounter}
                orientation={"horizontal"}
                className={css`margin-bottom: 1rem;`}
                steps={[
                    playerSelectionSteps.SELECT_PLAYER.title,
                    playerSelectionSteps.PLAYER_INFO.title
                ]}
            />
            {
                stepCounter === playerSelectionSteps.SELECT_PLAYER.activeStep &&
                <SelectPlayerFromList gameTeamId={gameTeamId} selectedPlayer={handleSelectNewPlayer}/>
            }
            {
                stepCounter === playerSelectionSteps.PLAYER_INFO.activeStep &&
                <AddPlayerToTeam
                    gameTeamId={gameTeamId}
                    playerInfo={playerInfo}
                    handleBackPage={_ => {
                        setStepCounter(playerSelectionSteps.SELECT_PLAYER.activeStep)
                    }}
                    handleClosePlayerSelectionDialog={handleClosePlayerSelectionDialog}
                />
            }

        </RaikoGridOneColumn>

    )
}
const playerSelectionSteps = {
    SELECT_PLAYER: {
        activeStep: 0,
        title: "انتخاب بازیکن"
    },
    PLAYER_INFO: {
        activeStep: 1,
        title: "اطلاعات بازیکن"
    },
}

